"use strict";

import React from "react";

function DialogOverlay(props) {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        backgroundColor: "rgba(9,9,9,.65)",
      }}
    >
      <div
        style={{ position: "absolute", height: "100%", width: "100%" }}
        onClick={props.onClick}
      ></div>
      <div
        style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)" }}
      >
        {props.children}
      </div>
    </div>
  );
}

export default DialogOverlay;
